<template>
  <div id="CategoryManage" class="section">
    <div class="columns is-multiline">
      <div class="column is-10-desktop is-10-tablet is-12-mobile">
        <h1 class="title">
          CATEGORY MANAGER
        </h1>
      </div>
      <div class="column is-12-mobile">
        <b-button
          expanded
          type="is-primary"
          icon-left="plus"
          @click.prevent="navigateToCategoryDetailPage"
        >
          Add Category
        </b-button>
      </div>
    </div>

    <div class="container">
      <category-table />
    </div>
  </div>
</template>

<script>
import CategoryTable from "@/components/tables/CategoryTable";

export default {
  name: "CategoryManage",
  components: {
    CategoryTable
  },
  methods: {
    navigateToCategoryDetailPage: function() {
      this.$router.push({ name: "category-detail" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#CategoryManage {
  text-align: left;
}
</style>
